import React from 'react'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { fetchImmunizationResultsThunk, setErrorState } from '../actions/api'
import BackButton from '../components/backButton'
import Footer from '../components/footer'
import ImmunizationsLowerInfo from '../components/immunizationLowerInfo'
import ImmunizationsSideInfo from '../components/immunizationSideInfo'
import Loading from '../components/loading'
import NavBar from '../components/navbar'
import PrintPVCButton from '../components/printPVCButton'
import ResultBoxUser from '../components/resultBoxUser'
import UserCard from '../components/usercard'
import TermsOfUseLink from '../components/termsOfUseLink'
import * as settings from '../globals/settings'


class ImmunizationScreen extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            user: props.user,
            sendLoginAlert: false
        }
    }

    componentDidMount() {
        if (settings.DEBUG === "true") {
            return;
        }
        
        this.getResults();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.language !== prevProps.language) {
            this.getResults();
        }
    }

    getResults() {
        try {
            let userId = null;
            if (this.props.selectedUser !== undefined && this.props.selectedUser !== null && this.props.selectedUser.isDependent !== null && this.props.selectedUser.isDependent === true) {
                userId = this.props.selectedUser.id;
            }
            this.props.dispatch(fetchImmunizationResultsThunk(userId));
        } catch(err) {
            if (err !== null && err !== undefined) {
                if(err.code === 'ARE' || err.code === 'ADE') {
                    this.setState({sendLoginAlert: true})
                } else if (err.code === 'SIE' || err.code === 'MIE' || err.code === 'LREE' || err.code === 'DAE' || err.code === 'PVE') {
                    this.props.dispatch(setErrorState(true, err.message, true));
                } else {
                    this.props.history.push("/");
                }
            }
        }
    }

    renderUser() {
        if (this.props.user === null || this.props.user === undefined) {
            return null;
        } else {
            return <UserCard user={this.props.user} language={this.props.language} />
        }
    }

    renderPassportBtn() {
        const currentPage = this.props.history.location.pathname
        return (
            <div className="btn btn-block btn-lg passport-btn">
                <Link className="text-decoration-none"
                      to={{pathname: '/vaccination_pass', state: {prevPath:currentPage}, user: this.props.selectedUser}}>
                    <p className="my-0">{this.props.strings.VACCINE_PASSPORT}</p>
                    <p className="use-in-nb my-0">{this.props.strings.VACCINE_PASSPORT_USE_NB}</p>
                </Link>
            </div>
        )
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }

        // FIXME Remove fake login!!!
        if ((this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true) || this.state.sendLoginAlert) {
            return <Redirect to={{
                pathname: "/",
                state: { loginAlert: this.state.sendLoginAlert }
            }}/>
        }

        if (this.props.isLoadingImmunizationResults === true) {
            return <Loading />
        }

        let results = this.props.immunizationResults.map(i => <ImmunizationResult {...i} language={this.props.language} strings={this.props.strings} />);
        if (results.length === 0) {
            results = <NoResult strings={this.props.strings} />
        }

        return (
            <>
                <NavBar isLoggedIn={this.props.isLoggedIn} language={this.props.language} />
                <div className="container immunzations-container">
                        <div className="row">
                            <div className="d-inline d-lg-none">
                                <div className="col-12">
                                    <BackButton />
                                </div>
                            </div>

                            <div className="col-12 col-lg-4 col-md-12 order-1 order-sm-1 order-md-1 order-lg-2">
                                {/* User card */}
                                {this.renderUser()}
                                <TermsOfUseLink />

                                {/* Vaccine passport button */}
                                {/*<div className="mt-5 mb-2">{this.renderPassportBtn()}</div> */}

                                {/* Federal vaccine PVC button */}
                                {(results.length > 0) ? <div className="mt-3 mb-5"><PrintPVCButton /></div> : <div className="mb-2" /> }

                                {/* Side info */}
                                <div className="mb-5 hideMobile"><ImmunizationsSideInfo /></div>
                            </div>

                            <div className="col-12 col-lg-8 order-1 order-md-1 order-lg-1 px-0">
                                <div className="immunizations-banner">
                                    <div className="d-none d-lg-inline"><BackButton /></div>
                                    <div className="border-top-line-auto" />
                                    <div className="immunizations-title">
                                        <h4>{this.props.strings.IMMUNIZATIONS_HEADER}</h4>
                                    </div>

                                    <ResultBoxUser className="px-0 mx-0" />

                                    {/* Immunization results */}
                                    <div className="row">
                                        <div className="col-12">
                                            <table className="table immunizations-table">
                                                <thead className="immunizations-table-header">
                                                    <tr>
                                                        <th scope="col" className="text-center">
                                                            {this.props.strings.IMMUNIZATIONS_RESULTS_VACCINE_DATE_1}
                                                            <br/>
                                                            {this.props.strings.IMMUNIZATIONS_RESULTS_VACCINE_DATE_2}
                                                        </th>
                                                        <th scope="col">
                                                            {this.props.strings.IMMUNIZATIONS_RESULTS_VACCINE_TYPE}
                                                        </th>
                                                        <th scope="col">
                                                            {this.props.strings.IMMUNIZATIONS_RESULTS_VACCINE_NAME}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {results}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="border-top-line-auto" />
                                    <div className="mt-3">
                                        <ImmunizationsLowerInfo />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer />
            </>
        )
    }
}

function ImmunizationResult(props) {
    return (
        <tr className="immunizations-table-row">
            <td className="text-center"><b>{props.immunizationDate}</b></td>
            <td><b>{props.immunizationType}</b></td>
            <td><b>{props.immunizationName}</b></td>
        </tr>
    );
}

// Pretty much the same as an ImmuizationResult but split in case they diverge stylistically
function NoResult(props) {
    return (
        <tr className="immunizations-table-row-no-results">
            <td><b>{props.strings.IMMUNIZATIONS_NO_RESULTS_DESC}</b></td>
            <td />
            <td />
        </tr>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isLoadingImmunizationResults: state.api.isLoadingImmunizationResults,
        immunizationResults: state.api.immunizationResults,
        selectedUser: state.api.selectedUser,
        isError: state.api.isError,
        deviceType: state.api.deviceType,
    }
}

const ConnectedImmunizationScreen = connect(
    mapStateToProps
)(ImmunizationScreen);
export default ConnectedImmunizationScreen;
